import { trim, kebabCase } from "lodash/string"
import { compact, concat } from "lodash/array"
import { isomorphicVars } from "./isomorphicVars"

export const getFileTypeFromUrl = (url, defaultType) => {
  const fileName = url.match(/[^/\\&\?]+\.\w{3,4}(?=([\?&].*$|$))/gim)[0] || ""
  return fileName.match(/\.[0-9a-z]+$/gim)[0] || defaultType || ""
}

// is key click
export function isKeyClick(e) {
  // checking for enter keys, or space key
  if (e.keyCode === 0 || e.keyCode === 32 || e.keyCode === 13) {
    return true
  } else {
    return false
  }
}

// Same as $(el).outerHeight(true);
export function outerHeight(el) {
  var height = el.offsetHeight
  var style = getComputedStyle(el)

  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10)
  return height
}

function quoteTerm(term) {
  return trim(term).replace(/"/g, '"')
}

//Used in Search params, and in prepare params of rotes.js
export function createSearchString(q, queryTerms = []) {
  if (!queryTerms || !queryTerms.length) return quoteTerm(q)

  //Remove empty values, and concat q and queryterms into a single array
  const terms = compact(concat([], q, queryTerms))

  if (terms.length === 1) return quoteTerm(terms[0])
  // Wrap each term in quotes, escaping quotes in terms
  else return quoteTerms(terms, "AND")
}

export function quoteTerms(terms, join = "OR") {
  return terms.map(term => `(${quoteTerm(term)})`).join(" " + join + " ")
}

// Parse client side cookie string
export function parseDocumentCookies() {
  return document.cookie
    .split(";")
    .map(x => x.trim().split("="))
    .reduce((a, b) => {
      a[b[0]] = b[1]
      return a
    }, {})
}

export function pad(pad, str, padRight) {
  if (typeof str === "undefined") return pad
  if (padRight) {
    return (str + pad).substring(0, pad.length)
  } else {
    return (pad + str).slice(-pad.length)
  }
}

export function formatBytes(bytes, decimals) {
  if (bytes === 0) return "0 Byte"
  var k = 1024 // or 1024 for binary ( this was 1000 )
  var dm = decimals + 1 || 3
  var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
  var i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

export function getPublicUrl(relative = "") {
  const { public_url: publicUrl } = isomorphicVars()

  return publicUrl.replace(/\/$/, "") + "/" + relative.replace(/^\//, "")
}

export function getPageMeta({ title, description, image }) {
  //UGH, has to be a better way that this
  let meta = [
    { property: "og:title", content: title },
    { name: "twitter:title", content: title },
    { property: "og:type", content: "article" }
  ]

  if (description) {
    meta = meta.concat([
      { name: "description", content: description },
      { name: "twitter:description", content: description },
      { property: "og:description", content: description }
    ])
  }

  if (image) {
    meta = meta.concat([
      { property: "og:image", content: image },
      { name: "twitter:image", content: image }
    ])
  }

  return meta
}

// basic user agent checks (taken from pdfjs)... potentially could be better, if you want to upgrade
// use like if(userAgent().isSafari){then go this}
export function userAgent() {
  const userAgent = navigator && navigator.userAgent

  const userAgentChecks = {
    // isAndroid: userAgent && /Android/.test(userAgent),
    // isAndroidPre3: userAgent && /Android\s[0-2][^\d]/.test(userAgent),
    // isAndroidPre5: userAgent && /Android\s[0-4][^\d]/.test(userAgent),
    // isChrome: userAgent && userAgent.indexOf("Chrom") >= 0,
    isIE: userAgent && userAgent.indexOf("Trident") >= 0,
    // isIOS: userAgent && /\b(iPad|iPhone|iPod)(?=,)/.test(userAgent),
    // isOpera: userAgent && userAgent.indexOf("Opera") >= 0,
    isSafari:
      userAgent &&
      /Safari\//.test(userAgent) &&
      !/(Chrome\/|Android\s)/.test(userAgent)
  }

  return userAgentChecks
}

export function usernameHack(userLogin) {
  if (userLogin.indexOf(" ") >= 0) {
    //Only do this if userLogin has spaces
    return kebabCase(userLogin)
  }
  return userLogin
}

export function loopSequence(array) {
  let i = 0

  return () => {
    if (i >= array.length) {
      i = 0
    }
    const value = array[i]
    i += 1
    return value
  }
}

export const replaceMarkdownLinks = textString => {
  const regex = /\[([^\[]+)\]\((.*)\)/gm

  try {
    return textString.replace(regex, '<a href="$2" target="_blank">$1</a>')
  } catch (error) {
    console.log("error", error)
    return textString
  }
}



// WEBPACK FOOTER //
// ./webapp/scripts/utils.js